/* ZAGO Custom Code for Search */
$(document).ready(function(){
  $(".Search__SearchBar_Mobile").click(function(){
    $("#sidebar-menu").css("opacity", '0');
    $("#sidebar-menu .Drawer__Close").click();
  });
  $("#section-header .Icon-Wrapper--clickable").click(function(){
    $("#sidebar-menu").css("opacity", '1');
  })
});